<template>
	<az-form class="pa-0">
		<v-data-table
			v-model="itensSelecionados"
			:items="itens"
			:headers="colunas"
			item-key="id"
			hide-default-footer
			show-select
			@paginar="tratarEventoPaginar"
			no-data-text="Nenhuma dotação por aqui"
			class="arp-listview"
		>
			<template #[`item.idOrgao`]="{ item }">
				{{ item.siglaOrgao }}
			</template>
			<template #[`item.exercicio`]="{ item }">
				{{ item.exercicio }}
			</template>
			<template #[`item.elementoSubElemento`]="{ item }">
				<span class="description-limitation">
					<texto-tooltip
						:texto="`${item.elementoSubElemento.codigo} - ${item.elementoSubElemento.descricao}`"
						:tamanho-maximo="40"
					></texto-tooltip>
				</span>
			</template>
			<template #[`item.funcaoProgramatica`]="{ item }">
				<span class="description-limitation">
					<texto-tooltip
						:texto="`${item.funcaoProgramatica.codigo} - ${item.funcaoProgramatica.descricao}`"
						:tamanho-maximo="40"
					></texto-tooltip>
				</span>
			</template>
			<template #[`item.fonteRecursoFinanceiro`]="{ item }">
				<span class="description-limitation">
					<texto-tooltip :texto="item.fonteRecursoFinanceiro.descricao" :tamanho-maximo="40"></texto-tooltip>
				</span>
			</template>
			<template #no-data>
				<v-row justify="center" class="row-size">
					<v-col class="pa-0">
						<v-icon size="60">mdi-inbox</v-icon>
						<h2>Nenhuma dotação orçamentária por aqui.</h2>
					</v-col>
				</v-row>
			</template>
			<paginacao-tabela
				v-if="totalItens > 0"
				:page.sync="paginacaoInterna.page"
				:rows-per-page.sync="paginacaoInterna.rowsPerPage"
				:totalPaginas="totalPaginas"
				:totalItens="totalItens"
				:show-rows-per-page="false"
			></paginacao-tabela>
		</v-data-table>
	</az-form>
</template>

<script>
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'selecao-dotacao-orcamentaria-listagem',
	components: { TextoTooltip, PaginacaoTabela },
	props: {
		itens: {
			type: Array,
			required: true,
		},
		paginacao: {
			type: Object,
			required: true,
		},
		totalItens: {
			type: Number,
			required: true,
		},
		totalPaginas: {
			type: Number,
			required: true,
		},
		value: {
			type: Array,
			required: true,
		},
	},

	data() {
		return {
			paginacaoInterna: this.paginacao,
			colunas: [
				{
					sortable: false,
					text: 'Órgão',
					value: 'idOrgao',
					align: 'start',
					width: '5%',
					class: 'primary--text',
				},
				{
					sortable: false,
					text: 'Exercício',
					value: 'anoExercicio',
					align: 'start',
					width: '5%',
					class: 'primary--text',
				},
				{
					sortable: false,
					text: 'Natureza Despesa ',
					value: 'elementoSubElemento',
					align: 'start',
					width: '25%',
					class: 'primary--text',
				},
				{
					sortable: false,
					text: 'Função Programática',
					value: 'funcaoProgramatica',
					align: 'start',
					width: '35%',
					class: 'primary--text',
				},
				{
					sortable: false,
					text: 'Fonte Recurso',
					value: 'fonteRecursoFinanceiro',
					align: 'start',
					width: '25%',
					class: 'primary--text',
				},
			],
		}
	},

	computed: {
		itensSelecionados: {
			set(newValue) {
				return this.$emit('input', newValue)
			},
			get() {
				return this.value
			},
		},
	},

	methods: {
		async tratarEventoPaginar(paginacao) {
			this.$emit('paginar', paginacao)
		},
	},
}
</script>
<style lang="stylus" scoped>
::v-deep .v-data-table__empty-wrapper
	height inherit !important
.row-size {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 22vh;
}
.description-limitation {
	text-overflow: ellipsis;
	overflow: hidden;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	display: block;
	display: -webkit-box;
	max-height: 48px;
}
</style>
